
import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  InvoiceDetails: (param) => {    // 发票管理-发票明细列表
    return GET('/merchant/billApplyRecord/queryBillApplyRecordByPage', param)
  },
  ExportedSymbols: (param, rsType) => {    // 发票管理-发票明细列表-导出列表
    return GETPDF('/merchant/billApplyRecord/billExport', param, rsType)
  },
  ExamineDetail: (param) => {    // 发票管理-发票明细列表-查看明细
    return GET('/merchant/billApplyRecord/querySellerBillApplyRecordInfoById', param)
  },
  InvoiceApply: (param) => {    // 发票管理-发票申请列表
    return GET('/merchant/accountRecharge/findRechargeList', param)
  },
  ListViewExport: (param, rsType) => {    // 发票管理-发票申请列表-列表导出
    return GETPDF('/merchant/accountRecharge/findRechargeExport', param, rsType)
  },
  ApplyInvoice: (param) => {    // 发票管理-发票申请列表-单击申请发票
    return GET('/merchant/billApplyRecord/queryCustomInfo', param)
  },
  SubmitBillApply: (param) => {    // 发票管理-发票申请列表-提交发票申请
    return POST('/merchant/billApplyRecord/applyForInvoicing', param)
  },
  QueryRecipients: (param) => {    // 发票管理-发票申请列表-查询收件人信息
    return GET('/merchant/expressInfo/queryExpressBy', param)
  },
  RecipientsRegulate: (param) => {    // 发票管理-收件人管理列表
    return GET('/merchant/expressInfo/queryByPage', param)
  },
  ReceiverExport: (param, rsType) => {    // 发票管理-收件人管理列表-导出列表
    return GETPDF('/merchant/expressInfo/export', param, rsType)
  },
  AddRecipient: (param) => {    // 发票管理-收件人管理列表-新增收件人
    return POST('/merchant/expressInfo/save', param)
  },
  DelRecipient: (param) => {    // 发票管理-收件人管理列表-删除收件人
    return GET('/merchant/expressInfo/delete', param)
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/invoice-regulate.js